const AIGrid = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-20">
      <div className="absolute inset-0" 
        style={{
          backgroundImage: `
            linear-gradient(hsl(var(--gradient-cyan) / 0.1) 1px, transparent 1px),
            linear-gradient(90deg, hsl(var(--gradient-cyan) / 0.1) 1px, transparent 1px)
          `,
          backgroundSize: '50px 50px',
          transform: 'perspective(500px) rotateX(60deg)',
          transformOrigin: 'center center',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-background" />
    </div>
  );
};

export default AIGrid;
